export default "__VITE_ASSET__DaPrf0$u__"